export const usePricingCellFocus = (_rowIndex: number, _columnId: string) => ({
  isAnchorSettled: true,
  onFocus: undefined,
});
